<script lang="ts">
  import { cn } from "$lib/utils";
  import { Mail } from "lucide-svelte";

  export let css = "";

  function copyToClipboard(event: MouseEvent) {
    const email = "help@chatsheet.com";
    // Copy to clipboard
    navigator.clipboard
      .writeText(email)
      .then(() => {
        // Use event.target instead of event.currentTarget for direct access
        const target = event.target as HTMLElement;
        if (target && target.getBoundingClientRect) {
          const rect = target.getBoundingClientRect();
          // Position the notification to the right of the button
          const notification = document.createElement("div");
          notification.innerText = "We're here for you 😎";
          notification.style.cssText = `
        position: absolute;
        top: ${rect.top + window.scrollY}px;
        left: ${rect.right + window.scrollX + 10}px;
        padding: 5px 10px;
        background-color: #222;
        color: white;
        border-radius: 0px;
        font-size: 0.75rem;
        z-index: 1000;
        white-space: nowrap;
      `;
          document.body.appendChild(notification);

          // Remove the notification after 3 seconds
          setTimeout(() => {
            document.body.removeChild(notification);
          }, 2000);
        } else {
          console.error("Failed to get bounding rectangle of the element");
        }
      })
      .catch((err) => {
        console.error("Failed to copy: ", err);
      });
    event.preventDefault();
  }
</script>

<div class={cn("border-theme-border-subtle relative border p-4 max-w-64 rounded-base", css)}>
  <div class="text-2xl font-semibold text-theme-text-primary">Questions?</div>

  <p class="mt-2 font-normal text-theme-text-primary">
    <Mail strokeWidth={1.5} size={18} class="mr-1 inline-block" />
    <button class="relative cursor-pointer underline" onclick={copyToClipboard}> help@chatsheet.com </button>
  </p>

  <a
    href="mailto:help@chatsheet.com"
    class="mt-6 block h-12 w-full border border-black bg-blog-green-bright py-2 text-center font-normal leading-[2rem] text-black transition-colors hover:bg-blog-green-bright/80 rounded-base"
  >
    Get in touch
  </a>
</div>
